module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "readButton",
    on: {
      "click": _vm.readSlide
    }
  }, [_c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "listenIcon",
    class: _vm.speechClass
  }, [_c('path', {
    attrs: {
      "d": "M55.3315655,60 C50.4262753,60 8.32400865,60 5,60 C5,48.8366699 9.20413794,39.2923521 19.2601482,35.4365191 C18.20282,34.284668 15.0820827,30.7830811 15.0820827,25.0223796 C15.0820827,18.3143916 20.7051722,10 30.1657827,10 C38.9673091,10 45.1986925,17.3539225 45.1986925,25.0223796 C45.1986925,31.9734701 41.1144757,35 41.1144757,35.4549123 C51.1375219,39.3226378 55.3315655,48.8543791 55.3315655,60 Z M56.5135468,0 C57.1358101,0.703613281 58.3803367,2.19213867 59.2822744,2.99804688 C53.1274711,9.984375 53.1134628,19.939209 59.3311806,26.5075684 C58.5597412,27.3359375 57.0635568,28.7272949 56.5626987,29.4289551 C48.1567374,22.3168945 48.2803545,7.24584961 56.5135468,0 Z M62.2035015,5 C62.7930788,5.62475586 64.4176886,7.10908194 65,7.62939453 C61.5874563,11.1784668 61.5874563,18.2973633 65,20.9943848 C64.5019413,21.5291986 62.5268669,23.1898146 62.2035015,23.6428223 C56.8599506,19.1608887 57.2792165,9.5625 62.2035015,5 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54f64b64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/readButton.vue
// module id = 624
// module chunks = 1